import { useContext, useEffect, useState } from "react";
import Barcode from "react-barcode";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Col,
  Row,
  Breadcrumb,
  Tag,
  Table,
  Skeleton,
  Space,
  Image,
  Descriptions,
  Modal,
  Form,
  Input,
  TimePicker,
  message,
  QRCode,
} from "antd";
import {
  EnvironmentOutlined,
  FieldTimeOutlined,
  FileTextOutlined,
  EditOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  EyeOutlined,
  NumberOutlined,
  CalendarOutlined,
  UserOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { useHttp } from "../../../utils/DataHendler";
import { UserContext } from "../../../context/User.context";
import dayjs from "dayjs";

export const LocationDetail = () => {
  const navigate = useNavigate();
  const { code } = useParams();
  const { getData, patchData } = useHttp();
  const { user } = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [detailData, setDetailData] = useState(null);

  // Edit modal state
  const [editModal, setEditModal] = useState({
    open: false,
    field: "",
    value: "",
  });
  const [form] = Form.useForm();

  useEffect(() => {
    fetchDetail();
    // eslint-disable-next-line
  }, [user, code]);

  const fetchDetail = async () => {
    setLoading(true);
    try {
      const response = await getData(`/location/${code}`, {}, true);
      setDetailData(response.data);
    } catch (err) {
      setDetailData(null);
    }
    setLoading(false);
  };

  // Handle edit button click
  const handleEdit = (field, value) => {
    setEditModal({
      open: true,
      field,
      value,
    });
    if (field === "start_time" || field === "end_time") {
      form.setFieldsValue({
        value: value ? dayjs(value, "HH:mm:ss") : null,
      });
    } else {
      form.setFieldsValue({ value });
    }
  };

  // Handle save edit
  const handleSaveEdit = async () => {
    try {
      const values = await form.validateFields();
      let patchValue = values.value;
      if (editModal.field === "start_time" || editModal.field === "end_time") {
        patchValue = values.value ? values.value.format("HH:mm:ss") : null;
      }
      await patchData(
        `/location`,
        { id: detailData.id, [editModal.field]: patchValue },
        true
      );
      message.success("Updated successfully");
      setEditModal({ open: false, field: "", value: "" });
      fetchDetail();
    } catch (err) {
      // validation error or patch error
    }
  };

  const columns = [
    {
      title: "No",
      key: "no",
      width: 60,
      render: (text, record, idx) => idx + 1,
      fixed: "left",
    },
    {
      title: "Inspection Time",
      dataIndex: "inspection_time",
      key: "inspection_time",
      width: 170,
      render: (val) =>
        val
          ? new Date(val).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "-",
      ellipsis: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 220,
      ellipsis: true,
    },
    {
      title: "Attachment",
      dataIndex: "attachment",
      key: "attachment",
      width: 120,
      render: (attachments) =>
        attachments && attachments.length > 0 ? (
          <Image
            src={attachments[0]}
            width={60}
            height={40}
            style={{ objectFit: "cover", borderRadius: 4 }}
            alt="Attachment"
            preview={{ src: attachments[0] }}
          />
        ) : (
          <Tag color="red">No Image</Tag>
        ),
    },
    {
      title: "Security",
      dataIndex: "security_username",
      key: "security_username",
      width: 120,
      ellipsis: true,
      render: (val, record) =>
        record.security_name ? `${record.security_name} (${val})` : val || "-",
    },
    {
      title: "Action",
      key: "action",
      width: 90,
      fixed: "right",
      render: (_, record) => (
        <Button
          icon={<EyeOutlined />}
          onClick={() => navigate(`/user/patrol/detail/${record.id}`)}
        />
      ),
    },
  ];

  return (
    <Row justify="center">
      <Col xs={24} sm={22} md={18} lg={14}>
        <div
          style={{
            marginBottom: "30px",
            borderBottom: "2px solid #088395",
            padding: "10px 15px 0px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Breadcrumb style={{ margin: 0 }}>
            <Breadcrumb.Item>
              <a onClick={() => navigate(-1)}>Dashboard</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontWeight: "bold" }}>
              Location Detail
            </Breadcrumb.Item>
          </Breadcrumb>
          <div
            style={{
              margin: 0,
              textAlign: "right",
              color: "#088395",
              fontWeight: "bold",
            }}
          >
            LOCATION DETAIL
          </div>
        </div>
        {loading || !detailData ? (
          <Skeleton active paragraph={{ rows: 6 }} />
        ) : (
          <>
            <Descriptions
              bordered
              size="small"
              column={1}
              style={{ marginBottom: 24 }}
              labelStyle={{ width: 180, fontWeight: "bold" }}
              contentStyle={{ textAlign: "left" }} // rata kiri untuk item
            >
              {/* <Descriptions.Item
                label={
                  <span>
                    <PictureOutlined style={{ marginRight: 6 }} />
                    Barcode
                  </span>
                }
              >
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  {detailData.code ? (
                    <div
                      style={{
                        background: "#fff",
                        padding: 8,
                        borderRadius: 8,
                        boxShadow: "0 2px 8px #f0f1f2",
                      }}
                    >
                      <QRCode value={detailData.code} />
                    </div>
                  ) : (
                    <Tag color="red">No Code</Tag>
                  )}
                </div>
              </Descriptions.Item> */}
              <Descriptions.Item
                label={
                  <span>
                    <NumberOutlined style={{ marginRight: 6 }} />
                    Code
                  </span>
                }
              >
                {detailData.code}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <FileTextOutlined style={{ marginRight: 6 }} />
                    Name
                  </span>
                }
              >
                {detailData.name}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <EnvironmentOutlined style={{ marginRight: 6 }} />
                    Latitude
                  </span>
                }
              >
                <Space>
                  {detailData.latitude}
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit("latitude", detailData.latitude)}
                  />
                </Space>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <EnvironmentOutlined style={{ marginRight: 6 }} />
                    Longitude
                  </span>
                }
              >
                <Space>
                  {detailData.longitude}
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() =>
                      handleEdit("longitude", detailData.longitude)
                    }
                  />
                </Space>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <FieldTimeOutlined style={{ marginRight: 6 }} />
                    Start Time
                  </span>
                }
              >
                <Space>
                  {detailData.start_time}
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() =>
                      handleEdit("start_time", detailData.start_time)
                    }
                  />
                </Space>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <FieldTimeOutlined style={{ marginRight: 6 }} />
                    End Time
                  </span>
                }
              >
                <Space>
                  {detailData.end_time}
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit("end_time", detailData.end_time)}
                  />
                </Space>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <FileTextOutlined style={{ marginRight: 6 }} />
                    Description
                  </span>
                }
              >
                <Space>
                  {detailData.description}
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() =>
                      handleEdit("description", detailData.description)
                    }
                  />
                </Space>
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <CheckCircleTwoTone
                      twoToneColor="#52c41a"
                      style={{ marginRight: 6 }}
                    />
                    Active
                  </span>
                }
              >
                {detailData.active ? (
                  <Tag color="green">Active</Tag>
                ) : (
                  <Tag
                    color="red"
                    icon={<CloseCircleTwoTone twoToneColor="#f5222d" />}
                  >
                    Inactive
                  </Tag>
                )}
              </Descriptions.Item>
              <Descriptions.Item
                label={
                  <span>
                    <CalendarOutlined style={{ marginRight: 6 }} />
                    Updated At
                  </span>
                }
              >
                {detailData.updated_at
                  ? new Date(detailData.updated_at).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "-"}
              </Descriptions.Item>
            </Descriptions>

            <div
              style={{
                margin: "10px 0 10px 0",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <h2 style={{ textAlign: "left" }}>Inspection List</h2>
              <Table
                dataSource={detailData.inspection_list?.map((item) => ({
                  ...item,
                  key: item.id,
                }))}
                columns={columns}
                scroll={{ x: 900 }}
                pagination={false}
                size="small"
                style={{ width: "100%" }}
              />
            </div>
            <Modal
              title={`Edit ${editModal.field.replace("_", " ").toUpperCase()}`}
              open={editModal.open}
              onCancel={() =>
                setEditModal({ open: false, field: "", value: "" })
              }
              onOk={handleSaveEdit}
              okText="Save"
              destroyOnClose
            >
              <Form form={form} layout="vertical">
                {editModal.field === "start_time" ||
                editModal.field === "end_time" ? (
                  <Form.Item
                    name="value"
                    label="Time"
                    rules={[{ required: true, message: "Please select time" }]}
                  >
                    <TimePicker format="HH:mm:ss" />
                  </Form.Item>
                ) : (
                  <Form.Item
                    name="value"
                    label="Value"
                    rules={[{ required: true, message: "Please input value" }]}
                  >
                    <Input />
                  </Form.Item>
                )}
              </Form>
            </Modal>
          </>
        )}
      </Col>
    </Row>
  );
};
